import './HowToGuideCard.scss'
import Heading from '../../Heading/Heading'
import { gaLinkEvent } from '../../../utils/trackingEvents/trackingEvents'
import LinkWithArrow from '../../LinkWithArrow/LinkWithArrow'
import Text from '../../../components/Text/Text'

const HowToGuideCard = ({
  url,
  image,
  imageRounded = 'false',
  headingText,
  description
}) => (
  <article>
    <div className="how-to-guide-card">
      <div>
        <div className="card-heading">
          <img src={image} alt={headingText} rounded={imageRounded} />
          <Heading type="h3" headingSize="h5" className="card-heading-title">
            {headingText}
          </Heading>
        </div>
        <Text>{description}</Text>
      </div>
      <LinkWithArrow
        to={url}
        external={true}
        onClick={() => gaLinkEvent('Open Document', headingText)}
        className="how-to-guide-card-link">
        Open Document <span className="u-visually-hidden">{headingText}</span>
      </LinkWithArrow>
    </div>
  </article>
)

export default HowToGuideCard
